
import { useEffect } from 'react';
import { MapMarkerRefs } from '../types';

export const useMarkerCleanup = (
  markerRefs: React.MutableRefObject<MapMarkerRefs>,
  mapContainer: HTMLElement | null,
  showFunding: boolean,
  showLowPresence: boolean,
  showUnreached: boolean,
  showAreasOfNeed: boolean,
  isMexicoView: boolean
) => {
  useEffect(() => {
    // Add classes to the map container based on view type
    if (mapContainer) {
      if (isMexicoView) {
        mapContainer.classList.add('mexico-view');
      } else {
        mapContainer.classList.remove('mexico-view');
      }
      
      // Add visibility classes based on toggle state
      if (!showFunding) {
        mapContainer.classList.add('hide-funding');
        document.body.classList.add('hide-funding');
      } else {
        mapContainer.classList.remove('hide-funding');
        document.body.classList.remove('hide-funding');
      }
      
      if (!showLowPresence) {
        mapContainer.classList.add('hide-low');
        document.body.classList.add('hide-low');
      } else {
        mapContainer.classList.remove('hide-low');
        document.body.classList.remove('hide-low');
      }
      
      if (!showUnreached) {
        mapContainer.classList.add('hide-unreached');
        document.body.classList.add('hide-unreached');
      } else {
        mapContainer.classList.remove('hide-unreached');
        document.body.classList.remove('hide-unreached');
      }
      
      if (!showAreasOfNeed) {
        mapContainer.classList.add('hide-need');
        document.body.classList.add('hide-need');
      } else {
        mapContainer.classList.remove('hide-need');
        document.body.classList.remove('hide-need');
      }
    }
    
    // Apply hide-funding class directly to document body for global effect
    if (!showFunding) {
      document.body.classList.add('hide-funding');
    } else {
      document.body.classList.remove('hide-funding');
    }
    
    return () => {
      console.log("MapMarkers: Cleaning up markers");
      
      markerRefs.current.regions.forEach(marker => marker.remove());
      markerRefs.current.regions = [];
      
      markerRefs.current.cities.forEach(marker => marker.remove());
      markerRefs.current.cities = [];
      
      markerRefs.current.churches.forEach(marker => marker.remove());
      markerRefs.current.churches = [];
      
      // Don't clean up label markers here to prevent them from disappearing
      
      // Remove the view classes
      if (mapContainer) {
        mapContainer.classList.remove('mexico-view');
        mapContainer.classList.remove('hide-funding');
        mapContainer.classList.remove('hide-low');
        mapContainer.classList.remove('hide-unreached');
        mapContainer.classList.remove('hide-need');
      }
      
      // Clean up body classes too
      document.body.classList.remove('hide-funding', 'hide-low', 'hide-unreached', 'hide-need');
    };
  }, [markerRefs, mapContainer, showFunding, showLowPresence, showUnreached, showAreasOfNeed, isMexicoView]);
};
